import isEmpty from "./isEmpty";
export default function joinParts(...parts) {
    return parts
        .map(it => it && it.trim())
        .filter(it => !isEmpty(it))
        .join(" ");
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/joinParts.ts